// extracted by mini-css-extract-plugin
module.exports = {"row":"Rows_row__ACrog","box":"Rows_box__jl_Yb"};